import React, { useState } from "react"
import { withRouter, Link } from "react-router-dom"
import MetaTags from "react-meta-tags"
import classnames from "classnames"
import {
  Container,
  Row,
  Col,
  Button,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  BreadcrumbItem,
} from "reactstrap"
import Table from "./Table"
import AuditLogs from "./AuditLogs"
import { useCanManageAffiliateBonuses } from "./permissions"
import { sitename } from "../../../constants/constants"

const AffiliateBonuses = props => {
  const [activeTab, setActiveTab] = useState("campaigns")
  const canEdit = useCanManageAffiliateBonuses()

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{sitename}</title>
        </MetaTags>
        <Container fluid>
          <Row>
            <Col xs="12">
              <div className="d-sm-flex align-items-center justify-content-between">
                <ol className="breadcrumb m-0">
                  <BreadcrumbItem>
                    <Link to="/affiliate/bonus-configuration">Affiliate</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>
                    <Link to="/affiliate/bonus-configuration">Bonus Configuration</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>
                    {activeTab === "campaigns" ? "Campaigns" : "Audit Logs"}
                  </BreadcrumbItem>
                </ol>
                {!canEdit && (
                  <span className="badge bg-info bg-opacity-10 text-info font-size-12 px-3 py-2">
                    <i className="mdi mdi-eye-outline me-1" />
                    Read-only access
                  </span>
                )}
              </div>
              <div className="d-sm-flex align-items-start justify-content-between mb-3">
                <div>
                  <h4 className="mb-1 font-size-18">Affiliate Registration Bonus</h4>
                  <p className="text-muted mb-0">
                    Configure and monitor bonuses awarded to affiliate-referred sign-ups.
                  </p>
                </div>
                {canEdit && (
                  <div>
                    <Button
                      type="button"
                      color="primary"
                      className="btn-rounded"
                      onClick={() => props.history.push("/affiliate/bonus-configuration/create")}
                    >
                      <i className="mdi mdi-plus me-1" />
                      New Campaign
                    </Button>
                  </div>
                )}
              </div>
            </Col>
          </Row>

          <Nav tabs className="mb-3">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "campaigns" })}
                onClick={() => setActiveTab("campaigns")}
                style={{ cursor: "pointer" }}
              >
                Campaigns
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "audit" })}
                onClick={() => setActiveTab("audit")}
                style={{ cursor: "pointer" }}
              >
                Audit Logs
              </NavLink>
            </NavItem>
          </Nav>

          <TabContent activeTab={activeTab}>
            <TabPane tabId="campaigns">
              <Table />
            </TabPane>
            <TabPane tabId="audit">
              <AuditLogs />
            </TabPane>
          </TabContent>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(AffiliateBonuses)
